module.exports = __webpack_public_path__ + "static/media/main idea.c192eebb.mp3";